module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133312503897525.c1f18baa.jpg";